/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ChangePassword.css";
import { simpleFetch } from "../../restWrapper";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import errorMsg from "../../assets/json/errMsg.json";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPw: "",
      newPw: "",
      confirmPw: "",
      err: [],
      submitting: false,
    };

    this._handleOldPw = (e) => {
      this.setState({
        oldPw: e.target.value,
      });
    };

    this._handleNewPw = (e) => {
      this.setState({
        newPw: e.target.value,
      });
    };

    this._handleConfirmPw = (e) => {
      this.setState({
        confirmPw: e.target.value,
      });
    };

    this._onSubmit = () => {
      if (this.state.submitting) return;

      const pwErr =
        (errorMsg[this.props.language] &&
          errorMsg[this.props.language].donorInfoErr) ||
        errorMsg.en.donorInfoErr;
      const languageObj = this.props.languageObj;

      if (this.state.newPw !== this.state.confirmPw) {
        this.setState({
          err: [languageObj.mismatchError || pwErr.reEnterPwErr],
        });
        return;
      }

      this.setState({ submitting: true, err: [] });

      simpleFetch("/donors/changepassword", "PUT", {
        oldPassword: this.state.oldPw,
        newPassword: this.state.newPw,
      })
        .then((res) => {
          if (res.status === 200 || res.status === 204) {
            this.props.history.push({
              pathname: "/ConfirmPassword",
              state: {
                color: this.props.location.state.color,
                organizationName: this.props.location.state.organizationName,
              },
            });
            return;
          }

          const errMsg = res.body && res.body.errors;
          let showErrText = [];
          if (errMsg) {
            if (errMsg.newPassword) {
              showErrText.push(pwErr.newPasswdErr);
            }
            if (errMsg.oldPassword) {
              showErrText.push(pwErr.passwdErr);
            }
          }
          if (showErrText.length === 0) {
            showErrText.push(
              (res.body && res.body.message) ||
                languageObj.failError ||
                "Please try again later."
            );
          }
          this.setState({
            submitting: false,
            err: showErrText,
          });
        })
        .catch(() => {
          this.setState({
            submitting: false,
            err: [languageObj.failError || "Please try again later."],
          });
        });
    };
  }

  render() {
    if (this.state.submitting) {
      return <this.props.RenderFullPageLoading />;
    }

    if (!this.props.location.state || !this.props.location.state.color) {
      return null;
    }

    const languageObj = this.props.languageObj;

    const backgroundOverrideStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };

    const buttonOverrideStyle = {
      background: "#" + this.props.location.state.color.headerColor,
      color: "#" + this.props.location.state.color.buttonColor,
    };

    const color = this.props.location.state.color;
    const organizationName = this.props.location.state.organizationName;

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this._onSubmit();
      }
    };

    return (
      <div className="ChangePassword-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="ChangePassword-bg" style={backgroundOverrideStyle} />
        <div className="ChangePassword-container">
          <div className="ChangePassword-header">
            <Link
              to={{
                pathname: "/AcInfo",
                state: {
                  color: color,
                  organizationName: organizationName,
                },
              }}
            >
              <div className="ChangePassword-backContainer">
                <div className="ChangePassword-back">
                  <div className="ChangePassword-backBtn"></div>
                  <div className="ChangePassword-backText">
                    {languageObj.backBtn}
                  </div>
                </div>
              </div>
            </Link>

            <div className="ChangePassword-headingTextContainer">
              <div className="ChangePassword-headingText">
                {languageObj.headingText}
              </div>
            </div>

            <div
              className={`ChangePassword-nextBtn ${this.state.submitting ? "ChangePassword-nextBtn-disabled" : ""}`}
              onClick={this._onSubmit}
              style={buttonOverrideStyle}
            >
              <div className="ChangePassword-nextTxt">
                {this.state.submitting
                  ? languageObj.submitting || "Submitting..."
                  : languageObj.submitBtn}
              </div>
            </div>
          </div>

          <div className="ChangePassword-main">
            <div className="ChangePassword-fieldbtn">
              <div className="ChangePassword-inputFieldContainer">
                <input
                  type="password"
                  onChange={this._handleOldPw}
                  className="ChangePassword-inputField"
                  placeholder={languageObj.currentPassword}
                  disabled={this.state.submitting}
                  onKeyDown={handleKeyDown}
                />
              </div>
              <div className="ChangePassword-inputFieldContainer">
                <input
                  type="password"
                  onChange={this._handleNewPw}
                  className="ChangePassword-inputField"
                  placeholder={languageObj.newPassword}
                  disabled={this.state.submitting}
                  onKeyDown={handleKeyDown}
                />
              </div>

              <div className="ChangePassword-inputFieldContainer">
                <input
                  type="password"
                  onChange={this._handleConfirmPw}
                  className="ChangePassword-inputField"
                  placeholder={languageObj.reenterPassword}
                  disabled={this.state.submitting}
                  onKeyDown={handleKeyDown}
                />
              </div>
              {this.state.err.map((err) => renderErrorMsg(err))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ChangePassword.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
  RenderFullPageLoading: PropTypes.func,
};

export default ChangePassword;
